let appRootElement = document.getElementById('js_foreground')
let appRootElementStyle = {} // preserve origin element style

function setAppElement(el) {
  appRootElement = el
}

let windowScrollPosition = 0

function freezeMainContent() {
  if (appRootElement) {
    windowScrollPosition = window.pageYOffset
    let style = appRootElement.style
    appRootElementStyle.position = style.position
    appRootElementStyle.overflow = style.overflow
    appRootElementStyle.top = style.top
    // freeze the main content at the position the user left it
    style.position = 'fixed'
    style.overflow = 'hidden'
    style.top = `-${windowScrollPosition}px`
    // now scroll the window to the top of page (the frozen content remains in position)
    window.scrollTo(0, 0)
  }
}

function unfreezeMainContent() {
  if (appRootElement) {
    // restore the original style
    let style = appRootElement.style
    style.position = appRootElementStyle.position || ''
    style.overflow = appRootElementStyle.overflow || ''
    style.top = appRootElementStyle.top || 0
    // return the window to where it left it's scroll position
    window.scrollTo(0, windowScrollPosition)
  }
}

export { freezeMainContent, unfreezeMainContent, setAppElement }
